<template>
    <i :class="resolvedClass"
       :style="resolvedStyles"
       aria-hidden="true"
    />
</template>

<script setup>
// TODO: This needs to be converted to a DevDash component. To fully integrate with the system design.
import { computed } from "vue";
import { iconRegistry } from "@common/icon/iconRegistry";

const props = defineProps({
    name: String,
    size: String,
    color: String
});

const sizeClassMap = {
    xs: "--text-size-caption",
    sm: "--text-size-subtitle",
    base: "--text-size-base",
    lg: "--text-size-headline",
    xl: "--text-size-h4",
    '2xl': "--text-size-h3",
    '3xl': "--text-size-h2",
    '4xl': "--text-size-h1",
};

const resolvedStyles = computed(() => {
    const sizeVar = sizeClassMap[props.size] ?? sizeClassMap.base;

    return {
        fontSize: `var(${sizeVar})`,
        color: props.color || 'var(--text-color-body)'
    };
});

const resolvedClass = computed(() => iconRegistry[props.name] || props.name);

// TODO: future--deliver messages to developer in dev mode.
// if (process.env.NODE_ENV === 'development') {
//     if (props.name && props.fa) {
//         console.warn(
//             `[Icon] Both 'name' and 'fa' were provided. 'name' takes priority.`
//         )
//     }
//
//     if (!props.name && !props.fa) {
//         console.warn(`[Icon] No icon provided.`)
//     }
// }

</script>
